export const ordersConstants = {
  LIST_ORDERS_REQUEST: "ORDERS_LIST_ORDERS_REQUEST",
  LIST_ORDERS_SUCCESS: "ORDERS_LIST_ORDERS_SUCCESS",
  LIST_ORDERS_FAILURE: "ORDERS_LIST_ORDERS_FAILURE",
  RETRIEVE_ORDER_REQUEST: "ORDERS_RETRIEVE_ORDER_REQUEST",
  RETRIEVE_ORDER_SUCCESS: "ORDERS_RETRIEVE_ORDER_SUCCESS",
  RETRIEVE_ORDER_FAILURE: "ORDERS_RETRIEVE_ORDER_FAILURE",
};